import * as React from 'react';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { BadgeList } from 'ui/badge-list';
import { ComponentProps } from 'ui/common';
import { GasTestResultShape } from 'app/area/case/selectors';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { MdOutlineGasMeter } from 'node_modules/react-icons/md';

interface FactItemGasTestProps extends ComponentProps, FactItemProps {
  numberOfGasTestMeasurements: number;
  gasTestResults: GasTestResultShape[];
  visibleForValues: string;
}

export const GasTestFactItem = (props: FactItemGasTestProps) => {
  const { tooltip, title, numberOfGasTestMeasurements, gasTestResults, url, linkDomain, portalTarget, visibleForValues } = props;
  const icon = <MdOutlineGasMeter />;

  const splittedVisibleForValues = !!visibleForValues && String(visibleForValues)
    ?.split(',')
    ?.map(e => Number(e));
  const filteredGasTestResults = !!splittedVisibleForValues?.length &&
    gasTestResults?.filter(r => splittedVisibleForValues.indexOf(r.key) > -1) || [];
  
  const totalGasTestMeasurements = [
    { value: numberOfGasTestMeasurements, tooltip }
  ];
  const resultingItems = [
  ...totalGasTestMeasurements,
  ...filteredGasTestResults
  ];

  if (!numberOfGasTestMeasurements) {
    return null;
  }
  
  return <FactLink id={props.componentId} classNames="fact-item" section={linkDomain} url={url}>
    <BadgeList
      icon={icon}
      title={title}
      valueItems={resultingItems}
      useNestedIndicator={true}
      portalTarget={portalTarget}
    />
  </FactLink>;
};
